import PropTypes from 'prop-types';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const GenderPreview = ({ value, defaultValue = null }) => {
  const { t } = useTranslation('common');
  return !value ? defaultValue : t(`genders.${value}`);
};

export default memo(GenderPreview);

GenderPreview.propTypes = {
  defaultValue: PropTypes.any,
  value: PropTypes.string
};
